import {Modal} from "../modal.service";
import {MixpanelService} from "../../services/mixpanel.service";
import {Component} from "@angular/core";

@Component({
  selector: "action-modal/action-modal",
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss']
})
@Modal()
export class ActionModalComponent {
  bodyClass = null;
  title = null;
  message = "Are you sure?";
  okLabel = "OK";
  cancelLabel = "CANCEL";
  showOK = true;
  showCancel = true;

  constructor(/*private mixpanelService: MixpanelService*/){}

  ok: Function;
  cancel: Function;
  destroy: Function;
  closeModal: Function;
  response = "success";

  onCancel(): void {
    if (this.closeModal) this.closeModal();
    this.destroy();
    if (this.cancel) this.cancel();
    // this.mixpanelService.track('cancelModalClicked');
  }

  onOk(): void {
    if (this.closeModal) this.closeModal();
    this.destroy();
    if (this.ok) this.ok(this.response);
    // this.mixpanelService.track('okModalClicked');
  }
}
